const STATUSES = [
    'partially',
    'to_be_answered',
];

export const filterStatuses = (statuses: { key: string, name: string }[]) => {
    return statuses.filter((status) => !STATUSES.includes(status.key))
}